import {TimelineLite} from "gsap";
import {TheCrypt} from "../../TheCrypt";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {TheCryptGameMode} from "../../server/TheCryptGameMode";

export class FreespinIntroPresentation implements FlowStatePresentation {
    name: string = "FreespinWinPresentation";
    private _flowStateController: FlowStateController;

    shouldRun(): boolean {
        const isRestore: boolean = TheCrypt.model.isRestore,
            isFS: boolean = !TheCrypt.model.isNextNormal,
            freespinTriggeredThisSpin: boolean = TheCrypt.model.freespinTriggeredThisSpin;

        return (isRestore && isFS) || freespinTriggeredThisSpin;
    }

    start(controller: FlowStateController): void {
        this._flowStateController = controller;

        if (TheCrypt.autoPlayPlugin.turnOffAutoplayOnBonus) {
            TheCrypt.autoPlayPlugin.turnOffAutoplayOnBonus();
        }
        const tl: TimelineLite = TheCrypt.freespinIntro.show(() => this.complete(), TheCrypt.apiPlugin.isReplay);
    }

    public complete(): void {
        TheCrypt.setMode(TheCrypt.model.data.nextMode);
        const tl: TimelineLite = new TimelineLite();
        tl.add(TheCrypt.collectors.show(TheCrypt.model.isRestore));
        tl.add(() => {
            TheCrypt.keypadPlugin.show(0.2);
            this._flowStateController.finish();
        });
    }
}